import { Line, mixins } from 'vue-chartjs'
import { i18n } from '../i18n'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: i18n.t('linechart.date')
          },
          gridLines: {
            display: true // 수치마다 세로선 유무
          }
        }],
        yAxes: [{
          display: true,
          ticks: {
            suggestedMin: 0
          },
          scaleLabel: {
            display: true,
            labelString: i18n.t('linechart.temperature')
          }
        }]
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    })
    const HTML = this.generateLegend()
    this.$emit('generated', HTML)
  }
}



// WEBPACK FOOTER //
// ./src/util/LineChart.js